/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {secureTransfer} from '../api'

export const useMutationSecureTransfer = createReactQueryMutationHook('secureTransfer', secureTransfer)
